import { render, staticRenderFns } from "./ContentAddPage.vue?vue&type=template&id=250a2b4b&scoped=true"
import script from "./ContentAddPage.vue?vue&type=script&lang=js"
export * from "./ContentAddPage.vue?vue&type=script&lang=js"
import style0 from "./ContentAddPage.vue?vue&type=style&index=0&id=250a2b4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250a2b4b",
  null
  
)

export default component.exports